// Module Federation bootstrap pattern: async import allows shared modules to initialize
import('./bootstrap');
